module.exports = __webpack_public_path__ + "img/frct_token.parsec.39f7810.png";